import { TextInput} from "components/core"
import { FormikProps } from "formik"

export * from "./schema";

interface CreateTestingFacilityFormProps {
  form: FormikProps<{
    name: string,
    address: string,
    ghanaPostAddress: string,
    contactPerson: {
      fullName: string,
      emailAddress: string,
      phoneNumber: string,
    }
  }>;
}

export default function CreateTestingFacilityForm({ form }: CreateTestingFacilityFormProps){

  return (
    <div className="space-y-6 divide-y divide-gray-200">
      <div>
        <span className="text-xs font-light">Facility Information</span>
        <div className="grid grid-cols-3 gap-4 mt-2">
          <div className={"col-span-2"}>
            <TextInput
              id="name"
              label="Facility Name"
              placeholder="e.g. Facility One"
              required={true}
              {...form}
            />
          </div>

          <div className={"col-span-2"}>
            <TextInput
              id="address"
              label="Residential Address"
              placeholder="e.g. 123 Palm Avenue"
              required={true}
              {...form}
            />
          </div>
          <div>
            <TextInput
              id="ghanaPostAddress"
              label="GhanaPost Address"
              placeholder="e.g. GA-123-1234"
              required={true}
              {...form}
            />
          </div>

        </div>
      </div>
      <div>
        <span className="text-xs font-light">Contact Person Information</span>
        <div className="grid grid-cols-2 gap-4 mt-2">
          <div className={"col-span-2"}>
            <TextInput
              id="contactPerson.fullName"
              label="Full Name"
              placeholder="e.g. Kwaku Boadi"
              required={true}
              {...form}
            />
          </div>
          <div>
            <TextInput
              id="contactPerson.phoneNumber"
              label="Phone Number"
              placeholder="e.g. 0546789012"
              required={true}
              {...form}
            />
          </div>
          <div>
            <TextInput
              id="contactPerson.emailAddress"
              label="Email Address"
              placeholder="e.g. kwaku.boadi@example.com"
              {...form}
            />
          </div>

        </div>
      </div>
    </div>
  )
}